import { MediaLibraryFileModel } from './../../../../models/sales-funnel';
import { OfferPaymentTypeModel } from '../../offer/models/offer';

export enum ProductTypeStatusEnum {
  active = 'active',
  soon = 'soon',
}

export class ProductType {
  id!: number;
  name!: string;
  enum!: 'manual' | 'ai';
  svgIcon?: string;
  iconName!: string;
  isRecommended?: boolean;
  description?: string;
  subDescription?: string;
  productFeatures?: { title: string }[];
  status!: ProductTypeStatusEnum;
}

export class ProductTypeModel {
  id!: number;
  name!: string;
  icon!: string;
  image!: string;
  description!: string;
}

export class ProductCreationInput {
  name: string = '';
  shortDescription: string = '';
  description?: string = '';
  isGift?: boolean = false;
  isFeatured?: boolean = false;
  instructors?: number[];
  image?: MediaLibraryFileModel[];
  image_id?: number[];
  payment_type?: OfferPaymentTypeModel; //Same one used in creating offers
}
